import React from "react";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

import Modal from "components/Modal";

import { Options, ServiceRoleFilter } from "..";

export function ServiceTeamModal({
  loading,
  editMode,
  description,
  warningMessage,
  name,
  roles,
  defaultTeamMembers,
  disableActionButton,
  actionText,
  header,
  onChangeAdvisor,
  onSave,
  onClose,
}) {
  return (
    <Modal isModalOpen data-test="manage-service-team-modal" onClose={onClose}>
      {header}
      <Modal.Body>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "450px",
          }}
        >
          <p>{description}</p>
          <div data-test="filter-container">
            <Options data-test="service-role-filter">
              {name}
              {roles.map(
                ({ assignedAdvisors, advisorsPage, ...serviceRole }) => {
                  return (
                    <ServiceRoleFilter
                      loading={loading}
                      key={serviceRole.id}
                      serviceRole={serviceRole}
                      assignedAdvisors={assignedAdvisors}
                      defaultTeamMembers={defaultTeamMembers}
                      advisorsPage={advisorsPage}
                      editable={editMode || !serviceRole.isSynced}
                      onChangeAdvisor={onChangeAdvisor}
                    />
                  );
                }
              )}
            </Options>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div data-test="warning-message" style={{ textAlign: "left" }}>
            {warningMessage}
          </div>
          <div style={{ width: "320px", flexShrink: 0 }}>
            <React.Fragment>
              <Button style={{ width: "150px" }} onClick={onClose}>
                Cancel
              </Button>
              <Button
                style={{ width: "150px" }}
                onClick={onSave}
                loading={loading}
                disabled={loading || disableActionButton}
                positive
              >
                {actionText}
              </Button>
            </React.Fragment>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

ServiceTeamModal.propTypes = {
  loading: PropTypes.bool,
  editMode: PropTypes.bool,
  header: PropTypes.node,
  description: PropTypes.string,
  warningMessage: PropTypes.node,
  name: PropTypes.node,
  roles: PropTypes.array,
  defaultTeamMembers: PropTypes.array,
  disableActionButton: PropTypes.bool,
  actionText: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onChangeAdvisor: PropTypes.func.isRequired,
};

ServiceTeamModal.defaultProps = {
  loading: false,
  editMode: false,
  description: "",
  warningMessage: "",
  name: null,
  roles: [],
  defaultTeamMembers: [],
  disableActionButton: false,
  actionText: "Add",
  header: null,
};

export default ServiceTeamModal;
